import { gql } from '@apollo/client';

export const GENERATE_AI_RESPONSE = gql`
  mutation GenerateAIResponse($prompt: String!) {
    aiResponse(prompt: $prompt)
  }
`;
